import * as api from '../../services/task_type/api_task_type';
import * as apiCommon from '../../services/apiCommon';
import { browserHistory } from 'react-router';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import * as SagaCommon from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';
import * as SagasType from '../../constants/constant_saga_types';

export function* fetchListTaskTypeSaga(feathersApp) {
	yield takeLatest('FETCH_LIST_TASK_TYPE', callFetchListTaskType, feathersApp);
}

function* callFetchListTaskType(feathersApp, action) {
	const { silent, filters } = action;
	yield SagaCommon.showProgressListTable(silent);
	try {
		const dataParams = {
			filters,
			list_type: 'task_type'
		};
		const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
		yield call(SagaCommon.doneListTable, { rows: tableData.data, total_rows: tableData.total });
	} catch (error) {
		yield SagaCommon.showErrorListTable(error);
	}
}

export function* saveTaskTypeSaga(feathersApp) {
	yield takeEvery("SAVE_TASK_TYPE", callSaveTaskType, feathersApp);
}
function* callSaveTaskType(feathersApp, action) {
	const { tenant, user } = yield select();
	try {
		yield put({ type: 'SAVE_RECORD_INPROGRESS' });

		const params = { tenant, user, data: action.data };
		const result = yield call(api.saveTaskType, feathersApp, params);

		yield SagaCommon.doneSaveRecord(result, 'Task type was saved');
		yield put({
			type: SagasType.SIMPLE_FORM_SET_DATA,
			data: result
		});
		yield callFetchListTaskType(feathersApp, { silent: true });

	} catch (e) {
		yield SagaCommon.showErrorSaveRecord(e);
	}
}

export function* deleteTaskTypeFromListSaga(feathersApp) {
	yield takeEvery('DELETE_TASK_TYPE_FROM_LIST', callDeleteTaskTypeFromList, feathersApp);
}

function* callDeleteTaskTypeFromList(feathersApp, action) {
	yield deleteTaskType(feathersApp, action);
	yield delay(2000);
	yield callFetchListTaskType(feathersApp, { silent: true });
}

function* deleteTaskType(feathersApp, action) {
	yield put({ type: 'DELETE_RECORD_INPROGRESS' });
	try {
		const { id } = action;
		let result = null;
		if (id) {
			const state = yield select();
			const { tenant, user } = state;
			const params = { tenant, user, id };
			result = yield call(api.deleteTaskType, feathersApp, params);
			yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.TASK_TYPE } });
			yield callFetchListTaskType(feathersApp, { silent: true });
		}
		return result;
	} catch (error) {
		yield put({ type: 'DELETE_RECORD_ERROR', error })
	}
}

export function* deleteTaskTypeSaga(feathersApp) {
	yield takeEvery('DELETE_TASK_TYPE', callDeleteTaskType, feathersApp);
}

function* callDeleteTaskType(feathersApp, action) {
	const result = yield deleteTaskType(feathersApp, action);
	yield delay(2000);
	if (result) {
		browserHistory.push('/admin/task_type');
	}
}

export function* fetchTaskTypeForEditSaga(feathersApp) {
	yield takeEvery('FETCH_TASK_TYPE_BY_ID', callFetchTaskTypeForEdit, feathersApp);
}

function* callFetchTaskTypeForEdit(feathersApp, action) {
	const { tenant, user } = yield select();
	const { id } = action;
	const docType = DocType.TASK_TYPE;
	try {
		if (id) {
			yield put({ type: "FETCH_DATA_BY_ID_INPROGRESS", payload: { docType, id } });
			const fetchParams = { tenant, user, id };
			const doc = yield call(api.fetchTaskTypeById, feathersApp, fetchParams);
			yield SagaCommon.doneDataById(doc);
			yield put({
				type: SagasType.SIMPLE_FORM_SET_DATA,
				data: doc
			});
		}
	} catch (error) {
		yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
	}
}
